import React from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import './SnapHotspot.scss';

interface SnapHotspotProps {
	position: 'left' | 'right';
	width: number;
	isVisible: boolean;
}

export const SnapHotspot = ({ position, width, isVisible }: SnapHotspotProps) => {
	const classes = new BemClass('SnapHotspot');

	if (!isVisible) {
		return null;
	}

	return <div className={classes.mod({ [position]: true }).b()} style={{ width: `${width}px` }} />;
};
